<template>
  <div class="main">
    <div class="header">
      <div class="item">
        <div>当前店铺：</div>
        <div style="color: #D9001B;">{{ data.mallId }}</div>
      </div>
      <div class="item">
        <div>店铺名称：</div>
        <div style="color: #D9001B;">{{ data.mallName }}</div>
      </div>
      <div class="item">
        <div>店铺代码：</div>
        <div style="color: #D9001B;">{{ data.mallCode }}</div>
        <div v-if="data.mallCode" style="margin-left: 10px;">
          <el-button type="primary" @click="onCopy">复制</el-button>
        </div>
      </div>
      <template v-if="data.userId">
        <div class="item">
          <div>用户名：</div>
          <div style="color: #D9001B;">{{ data.userName }}</div>
          <div style="margin-left: 10px;">
            <el-button type="primary" @click="onChangeName">更换用户名</el-button>
            <el-button type="primary" @click="onChangePwd">修改密码</el-button>
          </div>
        </div>
        <div style="color: #9d9d9d;font-size: 12px;">用户名仅为系统登录使用。</div>
      </template>
    </div>
    <div class="content">
      <div style="margin-bottom: 15px;">
        <el-button type="primary" @click="onBind">绑定新店铺</el-button>
      </div>
      <el-table row-key="id" :data="data.mallInfos" border style="width: 100%" v-loading="tbLoading">
        <el-table-column prop="mallId" label="店铺编号" min-width="180" />
        <el-table-column prop="mallName" label="店铺名称" min-width="200" />
        <el-table-column prop="mallCode" label="店铺代码" min-width="300" />
        <el-table-column align="center" label="排序" width="120">
          <template slot-scope="{row, $index}">
            <el-button icon="el-icon-top" @click="setUp($index)" v-if="$index != 0"></el-button>
            <el-button icon="el-icon-bottom" @click="setDown($index)"
              v-if="$index != (data.mallInfos.length - 1)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="195px" fixed="right">
          <div slot-scope="{row}" style="text-align: right;" v-if="row.mallId != data.mallId">
            <el-button type="primary" @click="setCurrent(row)">当前店铺</el-button>
            <el-button type="danger" @click="onDelete(row)">删除店铺</el-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <change-name ref="changeName" @close-saved="getData" />
    <change-pwd ref="changePwd" @close-saved="getData" />
    <bind ref="bind" @close-saved="getData" />
  </div>
</template>
<script>
import changeName from "./changeName";
import changePwd from "./changePwd";
import bind from "./bind";

export default {
  components: {
    changeName,
    changePwd,
    bind,
  },
  data() {
    return {
      api: require('@/api/wx/mall').default,
      data: {
        logo: "",
        mallId: null,
        mallName: "",
        sysType: "",
        userId: null,
        userName: "",
        mallCode: "",
        mallInfos: [],
      },
      tbLoading: false
    }
  },
  methods: {
    getData() {
      console.log("getData");
      this.api.getLoginUser().then(res => {
        console.log("loginUser", res)
        this.data = {
          ...res,
          sysType: this.$platformJs.getName(res.platform)
        }
      })
    },
    onCopy() {
      navigator.clipboard.writeText(this.data.mallCode).then(() => {
        this.$message.success('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
        this.$message.error('复制失败');
      });
    },
    onChangeName() {
      this.$refs.changeName.openEdit({
        userId: this.data.userId,
        userName: this.data.userName,
      })
    },
    onChangePwd() {
      this.$refs.changePwd.openEdit({
        userId: this.data.userId,
        userName: this.data.userName,
      })
    },
    onBind() {
      this.$refs.bind.open()
    },
    setUp(index) {
      var mall1 = this.data.mallInfos[index];
      var mall2 = this.data.mallInfos[index - 1];

      var data = {
        mallId1: mall1.mallId,
        mallSort1: mall1.sort - 1,
        mallId2: mall2.mallId,
        mallSort2: mall2.sort + 1,
      }
      console.log("setUp", index, data);


      this.tbLoading = true;
      this.api.saveSort(data).then(res => {
        console.log("res", res)
        this.tbLoading = false;
        if (!res) {
          this.data.mallInfos[index].sort = data.mallSort1;
          this.data.mallInfos[index - 1].sort = data.mallSort2;
          this.data.mallInfos = this.data.mallInfos.sort((a, b) => a.sort - b.sort);
        } else {
          this.$message.error("保存失败");
        }
      })
    },
    setDown(index) {
      var mall1 = this.data.mallInfos[index];
      var mall2 = this.data.mallInfos[index + 1];

      var data = {
        mallId1: mall1.mallId,
        mallSort1: mall1.sort + 1,
        mallId2: mall2.mallId,
        mallSort2: mall2.sort - 1,
      }

      this.tbLoading = true;
      this.api.saveSort(data).then(res => {
        console.log("res", res)
        this.tbLoading = false;
        if (!res) {
          this.data.mallInfos[index].sort = data.mallSort1;
          this.data.mallInfos[index + 1].sort = data.mallSort2;
          this.data.mallInfos = this.data.mallInfos.sort((a, b) => a.sort - b.sort);
        } else {
          this.$message.error("保存失败");
        }
      })
    },
    setCurrent(data) {
      console.log("setCurrent", data.mallId);
      var malls_str = localStorage.getItem("mall_list");
      var malls = malls_str ? JSON.parse(malls_str) : [];
      var mall = malls.find(x => x.mallId == data.mallId);
      console.log("mall", mall)

      var user_info = localStorage.getItem("user-info");
      if (user_info) {
        var user = JSON.parse(user_info);
        user.logo = data.logoUrl;
        user.mallId = mall.mallId;
        user.mallName = mall.mallName;
        user.expirationDate = mall.expirationDate;
        localStorage.setItem("user-info", JSON.stringify(user));
      }
      localStorage.setItem("token", mall.token);
      window.location.reload();
    },
    onDelete(data) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.deleteMall(data.mallId).then(res => {
          this.$message.success("保存成功");
          this.getData();
        })
      }).catch(() => { });
    }
  }
}
</script>
<style lang="scss">
.main {

  .header {
    border: 1px solid #E4E7ED;
    padding: 10px;

    .item {
      height: 40px;
      display: flex;
      align-items: center;
    }
  }

  .content {
    margin-top: 20px;
    //min-height: 400px;
    border: 1px solid #E4E7ED;
    padding: 10px;
  }
}
</style>